// A type 3 may observe several company channels; observers are not online colleagues.
// Deduplication keeps the same user visible until their last presence source leaves.
export const mergePresence = sources => Array.from(new Map(
  Object.values(sources).flat().filter(user => !user.observer).map(user => [`${Number(user.uuid)}:${user.entreprise}`, user])
).values())
